import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import DatePicker from '../../../../../../../../../../General/DatePicker';
import handleNumericCheck from '../../../../../../../../../../../utils/HandleNumericKeys';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
const AddNewFunctionalStatus = ({ setIsRecordSaved, ...props }) => {
    const { isOpenFunctionalStatus, onClose, FunctionalStatus_Modal, mainFunctionalStatusModal, setMainFunctionalStatusModal, setObservationsData, onDeleteFunctionalStatus, functionalStatusDDData } = { ...props }

    let valModal = {}
    let ValidationModal = {
        FunctionalStatusValuesVal: "",
        FunctionalDateVal: "",
    }
    const [functionalStatusID, setFunctionalStatusID] = useState();
    const [functionalStatusValuesSelected, setFunctionalStatusValuesSelected] = useState(false);
    const [isEdit, setIsEdit] = useState(true)
    // const [selectedFunctionalStatusValues,setSelectedFunctionalStatusValues] = useState([])

    const [functionalStatusValidationModal, setFunctionalStatusValidationModal] = useState(ValidationModal)
    const [functionalStatusSaveUpdateModal, setFunctionalStatusSaveUpdateModal] = useState({})
    // const [mainFunctionalStatusModal, setMainFunctionalStatusModal] = useState(FunctionalStatus_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onFunctionalStatusSaved, setOnFunctionalStatusSaved] = useState(false)
    // const [del, setDel] = useState(false)
    // const [searchDropdown, setSearchDropdown] = useState(false);
    // const [functionalStatusValuesBody, setFunctionalStatusValuesBody] = useState({ "TableName": enumUtil.enumAPITableName.PatientImplantableDevice, "SearchParam": '' })
    const [is, setIs] = useState(false);
    console.log("functionalStatusData AddNewProblem", props)
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);


    useEffect(() => {
        // setPracticeID(PracticeID)
        if (props.functionalStatusID != null) {
            // setDel(true)
            setFunctionalStatusID(props.mainFunctionalStatusModal.functionalStatusID)
        } else {
          if (!onFunctionalStatusSaved) {
            setFunctionalStatusID(0);
            // setDel(false)
          } else {
            // setDel(true)
          }
        }
    }, [functionalStatusID])
    useEffect(() => {
        // setMainFunctionalStatusModal(FunctionalStatus_Modal)
        console.log("props.functionalStatusID",props.functionalStatusID)
            if (!isNull(props.mainFunctionalStatusModal?.FunctionalStatusID)) {
                // setProblemsID(props.functionalStatusID)
                if(props?.mainFunctionalStatusModal?.FunctionalStatusID){
                    // setMainFunctionalStatusModal({ 
                    //     ...props?.mainFunctionalStatusModal, 
                    //     // FunctionalStatusID: props?.mainFunctionalStatusModal?.FunctionalStatusID,
                    //     // DiagnosisCode:  props?.mainFunctionalStatusModal?.DiagnosisCode,
                    //     // EncounterProblemID:  props?.mainFunctionalStatusModal?.EncounterProblemID,
                    //     // PatientProblemListID:  props?.mainFunctionalStatusModal?.PatientProblemListID,
                    //     // StartDate:  props?.mainFunctionalStatusModal?.StartDate,
                    //     // Description:  props?.mainFunctionalStatusModal?.DiagnosisDescription,
                    //     // Notes:  props?.mainFunctionalStatusModal?.ProblemNotes,
                    // })
                    if(props?.mainFunctionalStatusModal?.FunctionalStatusValuesID){
                        setIsEdit(false);
                        setFunctionalStatusValuesSelected(true);
                        setIs(true);
                    }
                }
            } else {
            console.log("props.functionalStatusID ELSEELSE", props?.mainFunctionalStatusModal)
                setMainFunctionalStatusModal({ 
                    ...FunctionalStatus_Modal, 
                    ...props?.mainFunctionalStatusModal, 
                    FunctionalStatusID: "",
                    // DiagnosisCode:  props?.mainFunctionalStatusModal?.DiagnosisCode, 
                });
                if(props?.mainFunctionalStatusModal?.FunctionalStatusValuesID){
                    setIsEdit(false);
                    setFunctionalStatusValuesSelected(true);
                    setIs(true);
                }
            }
    }, [props?.functionalStatusID]);

    const FunctionalStatusValidation = async () => {
        let ValidationModal = {
            FunctionalStatusValuesVal: FormValidator(
                mainFunctionalStatusModal.FunctionalStatusValues,
                enumUtil.enumValidationType.Required,
                'Functional Status',
            ),
            FunctionalDateVal: FormValidator(
                mainFunctionalStatusModal.FunctionalDate,
                enumUtil.enumValidationType.Required,
                'Date',
            ),

        }
        await setFunctionalStatusValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    // const handleSaveFunctionalStatus = async () => {
    //     await FunctionalStatusValidation()
    //     let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    //     if (validation) {
    //         NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
    //         return
    //     } else {
    //         // FunctionalStatusID
    //         // Deleted
    //         let saveModal = {
    //             // TableName: enumUtil.enumAPITableName.FunctionalStatus,
    //             FunctionalStatusID: functionalStatusID,
    //             ...functionalStatusSaveUpdateModal,
    //         };

    //         console.log("functionalStatusData saveModal 1", functionalStatusSaveUpdateModal )
            
    //         const clientRecordIDExist = props?.mainFunctionalStatusModal?.recordNoClient;
    //         let cogStatusID = functionalStatusID === 0 ? "" : functionalStatusID;
            
    //         // 🔁 Update FunctionalStatus in Observations
    //         setObservationsData(prev => {
    //             const functionalStatusList = [...(prev.FunctionalStatus || [])];
    //             console.log("functionalStatusData  functionalStatusList", functionalStatusList)
    //             const encounterLength = functionalStatusList.length;

    //             const idExist = functionalStatusList.some(
    //                 item => item.FunctionalStatusID === functionalStatusID
    //             );
    //             console.log("functionalStatusData  functionalStatusList idExist", idExist)

    //             const mainViewObj = {
    //                 recordNoClient: String(
    //                     idExist
    //                         ? Number(props?.mainFunctionalStatusModal?.recordNoClient) || 0
    //                         : encounterLength + 1
    //                 ),
    //                 ...props?.mainFunctionalStatusModal,
    //                 ...functionalStatusSaveUpdateModal,
    //                 FunctionalStatusID: props?.mainFunctionalStatusModal?.FunctionalStatusID ?? "",
    //                 // FunctionalStatusValuesID: cogStatusID ?? "",
    //                 ...(functionalStatusSaveUpdateModal.FunctionalStatusID ? { FunctionalStatusID: functionalStatusSaveUpdateModal.FunctionalStatusID } : {}),
    //             };

    //             let updatedList = [...functionalStatusList];

    //             console.log("functionalStatusData  functionalStatusList idExist clientRecordIDExist", clientRecordIDExist)
    //             console.log("functionalStatusData  functionalStatusList idExist functionalStatusID", functionalStatusID)
    //             if (clientRecordIDExist) {
    //                 const index = updatedList.findIndex(
    //                     item => String(item.recordNoClient) === String(clientRecordIDExist)
    //                 );
    //                 console.log("functionalStatusData  functionalStatusList idExist clientRecordIDExist index", index)
    //                 if (index !== -1) {
    //                     updatedList[index] = { ...mainViewObj };
    //                 } else {
    //                     updatedList.push(mainViewObj);
    //                 }

    //             } else if (isNull(functionalStatusID)) {
    //                 // ✅ New record, but check if FunctionalStatusValuesID already exists
    //                 const functionalStatusValuesID = mainViewObj.FunctionalStatusValuesID;

    //                 console.log("functionalStatusData  functionalStatusList idExist functionalStatusValuesID", functionalStatusValuesID)
    //                 const existingIndex = updatedList.findIndex(
    //                     item => item.FunctionalStatusValuesID === functionalStatusValuesID
    //                 );

    //                 console.log("functionalStatusData  functionalStatusList idExist existingIndex", existingIndex)
    //                 console.log("functionalStatusData  functionalStatusList mainViewObj", mainViewObj)

    //                 if (existingIndex !== -1) {
    //                     // Replace existing record with same FunctionalStatusValuesID
    //                     updatedList[existingIndex] = { ...mainViewObj };
    //                 } else {
    //                     updatedList.push(mainViewObj);
    //                 }

    //             } else if (idExist) {
    //                 updatedList = updatedList.map(item =>
    //                     item.FunctionalStatusValuesID === cogStatusID ? { ...mainViewObj } : item
    //                 );
    //             } else {
    //                 updatedList.push(mainViewObj);
    //             }

    //               console.log("functionalStatusData  functionalStatusList  updatedList", updatedList)
    //             return {
    //                 ...prev,
    //                 FunctionalStatus: updatedList
    //             };
    //         });

    //         // 💾 SaveProblemsData — do not include recordNoClient
    //         props?.setSaveFunctionalStatusData(prev => {
    //             const idExist = prev.some(item => item.FunctionalStatusID === functionalStatusID);
    //             const saveData = {
    //                 ...props?.mainFunctionalStatusModal,
    //                 FunctionalStatusID: props?.mainFunctionalStatusModal?.FunctionalStatusID ?? "",
    //                 FunctionalStatusValuesID: cogStatusID ?? "",
    //                 // PatientID: String(patientID),
    //                 // Acuity: mainProblemsModal.Acuity,
    //                 ...functionalStatusSaveUpdateModal,
    //             };

    //             // Remove `recordNoClient` if present
    //             delete saveData.recordNoClient;

    //             return isNull(functionalStatusID)
    //                 ? (prev.some(item => item.FunctionalStatusValuesID === saveData.FunctionalStatusValuesID)
    //                     ? prev.map(item =>
    //                         item.FunctionalStatusValuesID === saveData.FunctionalStatusValuesID ? { ...saveData } : item
    //                     )
    //                     : [...prev, saveData]
    //                 )
    //                 : (idExist
    //                     ? prev.map(item =>
    //                         item.FunctionalStatusID === functionalStatusID ? { ...saveData } : item
    //                     )
    //                     : [...prev, saveData]
    //                 );
    //         });

    //         onClose();
    //         return;

    //         // setObservationsData();
    //     }
    // }
    const handleSaveFunctionalStatus = async () => {
        await FunctionalStatusValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // let saveData = {
            //     FunctionalStatusID: functionalStatusID,
            //     ...functionalStatusSaveUpdateModal,
            // };
            let saveData = {
                ...mainFunctionalStatusModal,
                ...functionalStatusSaveUpdateModal,
                // recordNoClient: props?.mainFunctionalStatusModal?.recordNoClient,
            };

            // Ensure recordNoClient is set on unsaved documents, reuse if editing existing unsaved doc
            let currRecID = props?.mainFunctionalStatusModal?.FunctionalStatusID
            const isNew = isNull(currRecID) || currRecID === "";

            if (isNew) {
                // If editing an existing unsaved doc, keep its recordNoClient
                if (!saveData.recordNoClient) {
                    // If creating a new unsaved doc (no recordNoClient yet), generate once
                    saveData.recordNoClient = String(Date.now());
                }
            } else {
                // For saved docs, remove recordNoClient before sending to backend
                delete saveData.recordNoClient;
            }

            // const clientRecordIDExist = props?.mainFunctionalStatusModal?.recordNoClient;
            // let cogStatusID = functionalStatusID === 0 ? "" : functionalStatusID;

            // 🔁 Update FunctionalStatus in Observations
            setObservationsData(prev => {
                const functionalStatusList = [...(prev.FunctionalStatus || [])];
                // const encounterLength = functionalStatusList.length;

                // const idExist = functionalStatusList.some(
                //     item => item.FunctionalStatusID === functionalStatusID
                // );

                const mainViewObj = {
                    recordNoClient: saveData.recordNoClient || "",
                    ...props?.mainFunctionalStatusModal,
                    ...functionalStatusSaveUpdateModal,
                    FunctionalStatusID: props?.mainFunctionalStatusModal?.FunctionalStatusID ?? "",
                    ...(functionalStatusSaveUpdateModal.FunctionalStatusID
                        ? { FunctionalStatusID: functionalStatusSaveUpdateModal.FunctionalStatusID }
                        : {}),
                };

                let updatedList = [...functionalStatusList];

                if (isNew) {
                    const exists = functionalStatusList.some(d => d.recordNoClient === mainViewObj.recordNoClient);
                    updatedList = exists
                        ? functionalStatusList.map(d =>
                            d.recordNoClient === mainViewObj.recordNoClient ? mainViewObj : d
                        )
                        : [...functionalStatusList, mainViewObj];
                } else {
                    updatedList = functionalStatusList.map(d =>
                        d.FunctionalStatusID === currRecID ? mainViewObj : d
                    );
                }

                // if (clientRecordIDExist) {
                //     // Update or insert by recordNoClient
                //     const index = updatedList.findIndex(
                //         item => String(item.recordNoClient) === String(clientRecordIDExist)
                //     );
                //     if (index !== -1) {
                //         updatedList[index] = { ...mainViewObj };
                //     } else {
                //         updatedList.push(mainViewObj);
                //     }
                // } else if (isNull(functionalStatusID)) {
                //     // New record, but avoid duplicates by FunctionalStatusValuesID
                //     const functionalStatusValuesID = mainViewObj.FunctionalStatusValuesID;
                //     const existingIndex = updatedList.findIndex(
                //         item => item.FunctionalStatusValuesID === functionalStatusValuesID
                //     );

                //     if (existingIndex !== -1) {
                //         updatedList[existingIndex] = { ...mainViewObj };
                //     } else {
                //         updatedList.push(mainViewObj);
                //     }
                // } else if (idExist) {
                //     updatedList = updatedList.map(item =>
                //         item.FunctionalStatusValuesID === cogStatusID ? { ...mainViewObj } : item
                //     );
                // } else {
                //     updatedList.push(mainViewObj);
                // }

                return {
                    ...prev,
                    FunctionalStatus: updatedList
                };
            });

            props?.setSaveFunctionalStatusData(prev => {
                let cleanSaveData = { ...saveData };

                if (isNew) {
                    // Check if this unsaved doc already has a recordNoClient
                    if (!cleanSaveData.recordNoClient) {
                        // New unsaved doc, assign new recordNoClient
                        cleanSaveData.recordNoClient = String(Date.now());
                    }
                    // No backend ID yet
                    cleanSaveData.FunctionalStatusID = "";
                } else {
                    // Saved docs: remove recordNoClient before sending to backend
                    delete cleanSaveData.recordNoClient;
                    cleanSaveData.FunctionalStatusID = currRecID ?? "";
                }

                if (isNew) {
                    // Find existing unsaved doc by recordNoClient and update it
                    const existingIndex = prev.findIndex(
                        item => item.recordNoClient === cleanSaveData.recordNoClient
                    );

                    if (existingIndex !== -1) {
                        // Update existing unsaved doc
                        return prev.map((item, i) => (i === existingIndex ? { ...item, ...cleanSaveData } : item));
                    }

                    // Append new unsaved doc
                    return [...prev, cleanSaveData];
                } else {
                    // Saved docs: update by FunctionalStatusID or add if missing
                    const idExist = prev.some(doc => doc.FunctionalStatusID === cleanSaveData.FunctionalStatusID);

                    return idExist
                        ? prev.map(doc =>
                            doc.FunctionalStatusID === cleanSaveData.FunctionalStatusID ? cleanSaveData : doc
                        )
                        : [...prev, cleanSaveData];
                }
            });
            // 💾 SaveProblemsData — do not include recordNoClient
            // props?.setSaveFunctionalStatusData(prev => {
            //     const idExist = prev.some(item => item.FunctionalStatusID === functionalStatusID);
            //     const saveDataFinal = {
            //         ...props?.mainFunctionalStatusModal,
            //         FunctionalStatusID: props?.mainFunctionalStatusModal?.FunctionalStatusID ?? "",
            //         FunctionalStatusValuesID: cogStatusID ?? "",
            //         ...functionalStatusSaveUpdateModal,
            //     };

            //     delete saveDataFinal.recordNoClient;

            //     return isNull(functionalStatusID)
            //         ? (prev.some(item => item.FunctionalStatusValuesID === saveDataFinal.FunctionalStatusValuesID)
            //             ? prev.map(item =>
            //                 item.FunctionalStatusValuesID === saveDataFinal.FunctionalStatusValuesID ? { ...saveDataFinal } : item
            //             )
            //             : [...prev, saveDataFinal]
            //         )
            //         : (idExist
            //             ? prev.map(item =>
            //                 item.FunctionalStatusID === functionalStatusID ? { ...saveDataFinal } : item
            //             )
            //             : [...prev, saveDataFinal]
            //         );
            // });

            onClose();
            return;
        }
    };

    const handleChange = (e) => {
        setIs(false);
        let { name, value } = e.target
        let modal = { ...mainFunctionalStatusModal };
        let saveModal = { ...functionalStatusSaveUpdateModal }
        modal[name] = value
        setMainFunctionalStatusModal(modal)
        for (var property in FunctionalStatus_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setFunctionalStatusSaveUpdateModal(saveModal)
    }

    const handleDateChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainFunctionalStatusModal };
        let saveModal = { ...functionalStatusSaveUpdateModal }
        modal[type] = FormatedDate
        setMainFunctionalStatusModal(modal)
        for (var property in FunctionalStatus_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setFunctionalStatusSaveUpdateModal(saveModal)
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainFunctionalStatusModal };
        if (type === 'client' && !isNull(selectedData) && ![ -1, "-1"].includes(selectedData?.value)) {
            if (name === "FunctionalStatusValues") {
                modal[name] = selectedData.display;
                // functionalStatusSaveUpdateModal[name] = selectedData.display + "";
                modal['FunctionalStatusValuesID'] = selectedData.value + "";
                functionalStatusSaveUpdateModal['FunctionalStatusValuesID'] = selectedData.value + "";

                setIsEdit(false);
                setFunctionalStatusValuesSelected(true);
            }
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {

            modal[name] = ''
            functionalStatusSaveUpdateModal[name] = ''
            if (name === 'FunctionalStatusValues') {
                setFunctionalStatusValuesSelected(false);
                setMainFunctionalStatusModal(prev => ({
                  ...prev,
                  FunctionalStatusValues: "",
                  FunctionalStatusValuesID: ""
                }));
            }
        }
        setMainFunctionalStatusModal(modal)
        return selectedData
    }

    const FunctionalStatusName = () => {
      return (
        <p className="heading">Add New Functional Status</p>
      )
    }

    return (
        <Modal show={isOpenFunctionalStatus} onHide={isOpenFunctionalStatus} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {/* {DeleteConfirmation} */}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"FunctionalStatus"} HeaderName={FunctionalStatusName} 
                // isOpenDeleteAlert={isOpenDeleteAlert} 
                // onCloseDelete={onCloseDelete} 
                DeletePopup={""} 
                isClosed={onClose} />

                <div className="">
                    {isEdit ?
                        <div className={`input claims_info search-icon-icdSearch" form-group mb-12 ${functionalStatusValidationModal.FunctionalStatusValuesVal ? 'error' : ''}`}>
                            <SuperSearchList
                                type="client"
                                id='FunctionalStatusValues'
                                name='FunctionalStatusValues'
                                searchValue={mainFunctionalStatusModal.FunctionalStatusValues}
                                data={functionalStatusDDData}
                                onChange={handleChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                placeholder="Select type..."
                                inputError={functionalStatusValidationModal.FunctionalStatusValuesVal}
                            />
                            {functionalStatusValidationModal.FunctionalStatusValuesVal}
                        </div> :
                        <>
                            {console.log("functionalStatusData", mainFunctionalStatusModal.FunctionalStatusValues && mainFunctionalStatusModal.FunctionalStatusValues !== "Other")}

                            {
                                <div className="mb-2 d-flex align-items-center justify-content-between gap-15 px-1">
                                    <p className="text fs-13 font-m ar-dark-color validation_message text-nowrap"> <span className='text-decoration-underline'>{mainFunctionalStatusModal.FunctionalStatusValues}</span> <span className=''></span></p>
                                    <i className='icon-edit-pencil fs-12' onClick={() => setIsEdit(prev => !prev)}></i>
                                </div>
                            }
                        </>}
                    {functionalStatusValuesSelected &&
                        <>
                            <div className="d-flex align-items-end gap-15 mb-12">
                                <div className={`input mb-0 ${functionalStatusValidationModal.FunctionalDateVal ? 'error' : ''}`}>
                                    <DatePicker
                                        label="Date"
                                        className={`mb-0`}
                                        value={mainFunctionalStatusModal.FunctionalDate}
                                        handleCalendarChangefunc={date => handleDateChange(date, 'FunctionalDate')} />
                                    {functionalStatusValidationModal.FunctionalDateVal}
                                </div>
                            </div>
                            <div className='input' >
                                <label className="pb-3px">Notes</label>
                                <textarea 
                                    rows="3" 
                                    className="form-control"
                                    id='Notes'
                                    name='Notes'
                                    value={mainFunctionalStatusModal.Notes}
                                    onChange={handleChange}
                                />
                            </div>
                        </>}
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={handleSaveFunctionalStatus}>Save</button>
            </div>
        </Modal>
    )
}

export default AddNewFunctionalStatus